@if (gridData && resourceDef) {
    <dhs-data-grid #dhsgriddata [data]="gridData" [fields]="resourceDef.list.fields"
      [bulkActionsConfig]="resourceDef.list.bulkAction" [config]="config" (bulkActionClicked)="onBulkActionClicked($event)"
      (editEllipseClick)="buttonAction($event)">
    </dhs-data-grid>
    }